import React from "react";
import Page from "../../common/layout/Page";
import ReorientationsFilters from "./ReorientationsFilters";
import ReorientationsList from "./ReorientationsList";
import useReorientations from "./useReorientations";
import useReorientationTools from "./useReorientationTools";

const Reorientations = (props) => {
  var fetchId = props.match?.params?.id || props.userRecipientId || null;

  const {
    isLoading,
    organizations,
    reorientations,
    users,
    search,
    errors,
    changePage,
    changeNbItemsByPage,
    updateSearch,
    nbPages,
    nbResults,
    hasSearched,
    constants,
    openAssignModal,
    myOrgas,
    acceptReo,
    refuseReo,
    keepReo,
    resendReo,
    sendToEp,
    fetchReorientations,
    deleteReo,
    fromSites,
    toSites,
  } = useReorientations(fetchId, props.isModal);

  const { actions } = useReorientationTools({ organizations });

  return (
    <Page
      container={"container-fluid px-5"}
      title={`Liste des réorientations ${fetchId ? "de l'allocataire" : ""}`}
      bgTransparent
      errors={errors}
      noPadding
      back={fetchId && !props.isModal ? "/reorientations" : null}
    >
      {organizations.length && !fetchId && (
        <div className="mb-3">
          <ReorientationsFilters
            search={search}
            updateSearch={updateSearch}
            organizations={organizations}
            fetchReorientations={fetchReorientations}
            isLoading={isLoading}
            fromSites={fromSites}
            toSites={toSites}
          />
        </div>
      )}
      {/* Les colonnes lisent les organisations : lignes affichées une fois
          celles-ci chargées. Pour un allocataire, liste complète sans
          pagination, comme avant. */}
      <ReorientationsList
        reorientations={organizations.length ? reorientations : []}
        users={users}
        actions={actions}
        constants={constants}
        openAssignModal={openAssignModal}
        myOrgas={myOrgas}
        acceptReo={acceptReo}
        refuseReo={refuseReo}
        keepReo={keepReo}
        resendReo={resendReo}
        sendToEp={sendToEp}
        deleteReo={deleteReo}
        count={fetchId ? reorientations.length : nbResults}
        hasSearched={hasSearched || !!fetchId}
        isLoading={isLoading}
        {...(fetchId
          ? {}
          : {
              page: search.page,
              nbPages,
              nbItemsByPage: search.nbItemsByPage,
              onChangePage: changePage,
              onChangeNbItemsByPage: changeNbItemsByPage,
              itemLabel: "réorientations",
            })}
      />
    </Page>
  );
};

export default Reorientations;
